module.exports = __webpack_public_path__ + "static/media/Материали и предложения за решения за ОСА, насрочено за 30 юни 2025.991f7940.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2025/Материали и предложения за решения за ОСА, насрочено за 30 юни 2025.pdf
// module id = 87
// module chunks = 0